// extracted by mini-css-extract-plugin
export default {"text":"textApprovals_text__+nCzy"};